export default __webpack_public_path__ + "static/media/fondo-aztra.5085a13f.jpg";